import {
  DSCardWrapper,
  DSInput,
  DSTextarea,
} from "@components/design-system/molecules";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarEmpty } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import React from "react";
import { Controller, useWatch } from "react-hook-form";

import { alert } from "../../../../common/Alert";
import { RequiredAsterisk } from "../../../../common/RequiredAsterisk";
import { DEFAULT_TEMPLATE_EXAMPLES } from "../../../constants";
import ChooseTemplateType from "../ChooseTemplateType";

const MetadataSection = ({ handleTemplateTypeChange, control }) => {
  const formData = useWatch({ control });
  return (
    <DSCardWrapper
      variant="default"
      padding="p-md"
      dataTestId="metadata-section"
    >
      <div id="template-details">
        <div className="relative flex items-center mb-md">
          <div className="w-full">
            <label
              htmlFor="name"
              className="block text-sm font-semibold text-primary mb-1"
            >
              Name <RequiredAsterisk />
            </label>
            <Controller
              control={control}
              name="name"
              render={({ field }) => (
                <DSInput
                  type="text"
                  id="name"
                  name="name"
                  dataTestId="template-name-input"
                  placeholder={
                    formData?.templateType === "SOAP"
                      ? DEFAULT_TEMPLATE_EXAMPLES.SOAP.name
                      : DEFAULT_TEMPLATE_EXAMPLES.CUSTOM.name
                  }
                  value={formData?.name}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  required
                />
              )}
            />
          </div>
          <div className="absolute -top-1 right-1">
            <Controller
              name="isFavourite"
              control={control}
              render={({ field }) => (
                <label className="cursor-pointer">
                  <input
                    {...field}
                    type="checkbox"
                    className="sr-only"
                    checked={field.value}
                    onChange={(evt) => {
                      field.onChange(evt.target.checked);
                      alert(
                        "success",
                        `You've ${
                          evt.target.checked ? "marked" : "unmarked"
                        } this template as a favorite. ${
                          evt.target.checked
                            ? "It will now be displayed at the top of your templates list."
                            : "It will no longer be displayed at the top of your templates list."
                        }`,
                      );
                    }}
                  />
                  <Tooltip
                    title={`Click to ${
                      field.value ? "unmark" : "mark"
                    } this template as a favorite. ${
                      field.value
                        ? ""
                        : "If favorited, it will be displayed at the top of your templates list."
                    }`}
                    arrow
                    placement="left"
                  >
                    <div>
                      <FontAwesomeIcon
                        icon={field.value ? faStar : faStarEmpty}
                        size="lg"
                        className="text-yellow-500 hover:text-yellow-600 transition"
                      />
                    </div>
                  </Tooltip>
                </label>
              )}
            />
          </div>
        </div>
        {/* Description */}
        <div className="mb-md">
          <Controller
            control={control}
            name="description"
            render={({ field }) => (
              <DSTextarea
                id="description"
                name="description"
                label="Description"
                dataTestId="template-description-input"
                minRows={2}
                placeholder={
                  formData?.templateType === "SOAP"
                    ? DEFAULT_TEMPLATE_EXAMPLES.SOAP.description
                    : DEFAULT_TEMPLATE_EXAMPLES.CUSTOM.description
                }
                value={field.value}
                onChange={(e) => {
                  field.onChange(e);
                }}
              />
            )}
          />
        </div>

        <ChooseTemplateType
          handleTemplateTypeChange={handleTemplateTypeChange}
          formData={formData}
        />
      </div>
    </DSCardWrapper>
  );
};

export default MetadataSection;
